/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserClockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABrElEQVR4nOWUu0oDURCG10oQRBDstLZSELQRCxsl6M5li+NM9EG0sBNBn8BX0CD4BPEGvoJvoIg3NPHSSJQ5icnGZBOXjZUHpjl79v/m/PPvBsG/WEQyhiyHwFqyQpYjRDfeM3EgfUDWz+aSR3uWGYAsh63itSItZAaAtyQBwPL8pwAgfcoMQBtookVykB2AbtwG2tq93EfR2mjQs5iSFsxzXyQHPRP/02VdAsk6sJ4ByxWQflRLroH1HFk2nHPDqYVzuVw/suwiyXtyRH1Mb4hWJ9KJOzcCrBedhdUnyDk3lLrz34gD634QBH32DrAQkpwiy4sVsJ4Q5aEtwNvSrXOWG0QcrJ7XnQ5nt1sG2t1ztdqsdx7bJ5LZkPNzzTeVsA6wtPxC/BNAJ3333pbGfsOFJiuPGwAfu/o/5jIJEIbhQLUhLbcFkN7GAKX4Da5r4mUimU8LCKOVGdsPWRYTAPpW+8fsdQIg6lTtxic/hn9n4k1WkxRjCfKJeEXUaYh0AVkrbQAVovySnbcodp1ZpMupvpPWWOt2YhhItjKJfy+LoqXFZuLnQlKMd/4F4uPXKD61szcAAAAASUVORK5CYII=)
 */
export const UserClockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16 6a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM2 20.53A9.53 9.53 0 0 1 11.53 11h.94c1.28 0 2.5.25 3.61.7.41.18.36.77-.05.96a7 7 0 0 0-3.65 8.6c.11.36-.13.74-.5.74H6.15a.5.5 0 0 1-.5-.55l.27-2.6c.02-.26-.27-.37-.41-.16-.48.74-1.03 1.8-1.32 2.9a.53.53 0 0 1-.5.41h-.22C2.66 22 2 21.34 2 20.53Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M19 24a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm1-7a1 1 0 1 0-2 0v2c0 .27.1.52.3.7l1 1a1 1 0 0 0 1.4-1.4l-.7-.71V17Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
